module.exports = __webpack_public_path__ + "static/media/arrow-right.6ea486c2.svg";